import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { color } from '@deerplusofficial/pos-helper';
import { ButtonBase } from '@deerplusofficial/pos-components';

const Tab = styled(ButtonBase)`
  flex-grow: 1;
  padding: 8px;
  color: ${color.text.title};
  box-shadow: ${props =>
    props.active
      ? `inset 0 -2px 0 ${color.primary}`
      : `inset 0 -1px 0 ${color.border}`};
`;

export default class extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string,
    activeTab: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    name: '',
    activeTab: undefined,
    onClick: _.identity,
  };

  onClick = () => this.props.onClick(this.props.name);

  render() {
    const { children, activeTab, name, onClick, ...props } = this.props;

    return (
      <Tab active={activeTab === name} onClick={this.onClick} {...props}>
        {children}
      </Tab>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/Tab.js